<template>
    <table class="table">
        <tbody>
        <tr>
            <td>
                {{ $t('common.price') }}
            </td>
            <td class="text-right">
                {{getCurrencySymbolFromString(defaultCurrency)}}{{priceConverted}}
            </td>
        </tr>
        <tr>
            <td>
                {{ $t('common.service_fee') }}
            </td>
            <td class="text-right">

                {{getCurrencySymbolFromString(defaultCurrency)}}{{(getGrossPriceOnlineWithCreditCard(priceConverted)-priceConverted).toFixed(2)}}
            </td>
        </tr>
        <tr>
            <td>
                <b>{{ $t('common.total') }}</b>
            </td>
            <td class="text-right">
                <b>{{getCurrencySymbolFromString(defaultCurrency)}}{{getGrossPriceOnlineWithCreditCard(priceConverted)}}</b>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
    import {Utils} from "../../common/utils";

    export default {
        name: "PriceTable",
        props: {
            price: {
                type: String,
                required: true
            },
            currency: {
                type: String,
                required: true
            }
        },
        data: () => {
            return {
                priceConverted: 0,
                defaultCurrency: Utils.getDefaultCurrency(),
            }
        },
        async mounted() {
            this.priceConverted = await Utils.getPrice(this.price, this.currency);
        },
        methods: {
            getCurrencySymbolFromString(currency) {
                return Utils.getCurrencySymbolFromString(currency)
            },
            getGrossPriceOnlineWithCreditCard(price) {
                return Utils.getGrossPriceOnlineWithCreditCard(price)
            }
        },
        watch: {
            async price(newVal) {
                this.priceConverted = await Utils.getPrice(newVal, this.currency);
            }
        }
    }
</script>
